module.exports = __webpack_public_path__ + "img/logo.378d1cf5.png";